import {
  BriefcaseBusiness,
  ChartColumn,
  ChartLine,
  CircleCheck,
  Cloud,
  CodeXml,
  Cpu,
  Database,
  Globe,
  GraduationCap,
  HeartHandshake,
  Leaf,
  Lightbulb,
  Lock,
  Network,
  Search,
  Settings,
  ShieldCheck,
  Users,
  Wrench,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";
import gcloudPhoto from "../../assets/redesign/home/premio-gcloud-equipe.jpg";
import ciscoPhoto from "../../assets/redesign/home/premio-cisco-top3.jpg";
import googleEducation from "../../assets/redesign/logos/google-for-education.svg";
import rnp from "../../assets/logos/rnp-logo.png";
import redHat from "../../assets/redesign/logos/red-hat.svg";
import architect from "../../assets/redesign/certificacoes/cloud-architect.png";
import developer from "../../assets/redesign/certificacoes/cloud-developer.png";
import workspacePro from "../../assets/redesign/certificacoes/workspace-admin-pro.png";
import education from "../../assets/redesign/certificacoes/google-for-education.svg";
import engineer from "../../assets/redesign/certificacoes/cloud-engineer.png";
import dataPractitioner from "../../assets/redesign/certificacoes/data-practitioner.png";
import chromeosAdmin from "../../assets/redesign/certificacoes/chromeos-admin.png";
import workspaceAssoc from "../../assets/redesign/certificacoes/workspace-admin-assoc.png";

// Estrutura da página Sobre: ícones, imagens e links. Os textos ficam nos locales (sobre.*, sobre_page.* e, quando
// são os mesmos da Home, home.*); os valores daqui são o fallback em pt.

// Quem somos: prêmios em destaque (nomes oficiais, não traduzidos) e as áreas, na ordem de sobre_page.intro.areas
export const INTRO_AWARDS = [
  "Google Cloud Partner of the Year · Public Sector LATAM",
  "Cisco TOP 3 · SP Routing Excellence 2026",
];

export const AREAS: { key: string; Icon: LucideIcon }[] = [
  { key: "cloud", Icon: Cloud },
  { key: "network", Icon: Network },
  { key: "security", Icon: ShieldCheck },
  { key: "data", Icon: Database },
  { key: "edtech", Icon: GraduationCap },
  { key: "dev", Icon: CodeXml },
  { key: "support", Icon: Wrench },
];

// O que nos move: mesma ordem de sobre_page.pillars
export const PILLARS: { key: string; Icon: LucideIcon; title: string; text: string }[] = [
  {
    key: "technology",
    Icon: Cpu,
    title: "Tecnologia que transforma",
    text: "Infraestrutura digital, nuvem, colaboração e IA a serviço de empresas, governos e instituições de ensino.",
  },
  {
    key: "sustainability",
    Icon: Leaf,
    title: "Sustentabilidade",
    text: "Ambientes mais eficientes consomem menos: reduzimos custos operacionais e o impacto no planeta.",
  },
  {
    key: "innovation",
    Icon: Lightbulb,
    title: "Inovação com responsabilidade",
    text: "Adotamos o que há de mais novo com segurança, governança e respeito à LGPD.",
  },
  {
    key: "people",
    Icon: HeartHandshake,
    title: "Pessoas e educação",
    text: "Capacitamos equipes, professores e estudantes para que a mudança aconteça de verdade.",
  },
];

// números ao lado do Quem somos (valores que contam ao aparecer)
export const STATS = [
  { key: "users", value: "+500 mil", label: "usuários em Google Workspace sob gestão Calriz" },
  { key: "students", value: "+75 mil", label: "alunos simultâneos no Moodle FMU" },
  { key: "impact", value: "+1,5 mi", label: "pessoas impactadas pelo Moodle nos 41 Institutos Federais" },
  { key: "access_points", value: "+170", label: "pontos de acesso ativados no Nordeste" },
];

// ícones na mesma ordem de home.process.steps e home.expertise.items
export const PROCESS_ICONS = [Search, Settings, CircleCheck, BriefcaseBusiness, ChartLine];
export const EXPERTISE_ICONS = [Users, Cloud, ChartColumn, Lock, Globe];

// os dois prêmios com foto; textos em home.awards.<key>
export const AWARDS = [
  { key: "gcloud", brand: "Google Cloud", photo: gcloudPhoto, to: undefined as string | undefined },
  { key: "cisco", brand: "Cisco", photo: ciscoPhoto, to: "/blog/12" },
];

// parceiros estratégicos; textos em home.awards.<key>.text
export const PARTNERS = [
  { key: "rnp", logo: rnp, alt: "RNP" },
  { key: "google_education", logo: googleEducation, alt: "Google for Education" },
  { key: "red_hat", logo: redHat, alt: "Red Hat" },
];

// Nomes oficiais das certificações do Google (não traduzidos), os mesmos da Home.
export const CERTIFICATIONS = [
  { name: "Cloud Architect", level: "Professional", badge: architect },
  { name: "Cloud Developer", level: "Professional", badge: developer },
  { name: "Cloud Engineer", level: "Associate", badge: engineer },
  { name: "Data Practitioner", level: "Associate", badge: dataPractitioner },
  { name: "Workspace Administrator", level: "Professional", badge: workspacePro },
  { name: "Google Workspace Administrator", level: "Associate", badge: workspaceAssoc },
  { name: "ChromeOS Administrator", level: "Professional", badge: chromeosAdmin },
  { name: "Google for Education", level: "Credential", badge: education },
];
